import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const MAX_COMPANY_NAME_LENGTH = 200;

export const setCompanyName = mutator({
  schema: z.object({
    companyName: z.string().trim().min(1).max(MAX_COMPANY_NAME_LENGTH),
    previousCompanyName: z.string().nullable().optional(),
  }),
  resolve: {},
  permissions: [
    { permission: "allow_all", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args }) => {
    const tenant = await tx.run(zql.tenants.where("id", ctx.tenantId).one());
    if (
      !tenant ||
      (args.previousCompanyName !== undefined &&
        (tenant.companyName ?? null) !== args.previousCompanyName)
    ) {
      throw userFacingError(
        "The company name changed while you were editing. Reload the page and try again."
      );
    }
    ctx.recordAuditMetadata?.({
      companyName: { from: tenant.companyName ?? null, to: args.companyName },
    });
    await tx.mutate.tenants.update({
      id: ctx.tenantId,
      companyName: args.companyName,
      updatedAt: Date.now(),
    });
  },
});
